import { render, staticRenderFns } from "./UpdateDeliveryZone.vue?vue&type=template&id=36063780&"
import script from "./UpdateDeliveryZone.vue?vue&type=script&lang=js&"
export * from "./UpdateDeliveryZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports